import React, { useState, useEffect } from 'react';
import api from '../../api';
import AdminLayout from '../../components/AdminLayout';

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/dashboard').then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <AdminLayout><div className="spinner" /></AdminLayout>;

  return (
    <AdminLayout title="Dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Products</h3>
          <div className="value">{data.totalProducts}</div>
        </div>
        <div className="stat-card">
          <h3>Active Products</h3>
          <div className="value success">{data.activeProducts}</div>
        </div>
        <div className="stat-card">
          <h3>Total Orders</h3>
          <div className="value">{data.totalOrders}</div>
        </div>
        <div className="stat-card">
          <h3>Pending Orders</h3>
          <div className="value" style={{ color: '#f39c12' }}>{data.pendingOrders}</div>
        </div>
        <div className="stat-card">
          <h3>Revenue</h3>
          <div className="value success">${data.totalRevenue.toFixed(2)}</div>
        </div>
        <div className="stat-card">
          <h3>Low Stock Alerts</h3>
          <div className="value danger">{data.lowStockCount}</div>
        </div>
        <div className="stat-card">
          <h3>Customers</h3>
          <div className="value">{data.totalCustomers}</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <div>
          <h3 style={{ marginBottom: 12 }}>Recent Orders</h3>
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Order</th><th>Customer</th><th>Total</th><th>Status</th></tr>
              </thead>
              <tbody>
                {data.recentOrders.map(o => (
                  <tr key={o.id}>
                    <td>#{o.id}</td>
                    <td>{o.customer_name || 'Guest'}</td>
                    <td>${o.total.toFixed(2)}</td>
                    <td><span className={`badge badge-${o.status}`}>{o.status}</span></td>
                  </tr>
                ))}
                {data.recentOrders.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: 'center', padding: 20, color: '#999' }}>No orders yet</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <h3 style={{ marginBottom: 12 }}>Top Products</h3>
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Product</th><th>Sold</th><th>Revenue</th></tr>
              </thead>
              <tbody>
                {data.topProducts.map(p => (
                  <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>{p.total_sold}</td>
                    <td>${p.total_revenue.toFixed(2)}</td>
                  </tr>
                ))}
                {data.topProducts.length === 0 && (
                  <tr><td colSpan={3} style={{ textAlign: 'center', padding: 20, color: '#999' }}>No sales yet</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
